import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const tier1Areas = [
  { name: "Brickell", slug: "brickell", zips: ["33129", "33130", "33131"] },
  { name: "Aventura", slug: "aventura", zips: ["33160", "33180"] },
  { name: "Miami Beach", slug: "miami-beach", zips: ["33139", "33140", "33141"] },
  { name: "Coral Gables", slug: "coral-gables", zips: ["33134", "33143", "33146"] },
  { name: "Doral", slug: "doral", zips: ["33122", "33166", "33172", "33178"] },
  { name: "Coconut Grove", slug: "coconut-grove", zips: ["33133"] },
];

const serviceKeys = [
  "serviceAreas.svcSliding",
  "serviceAreas.svcHardware",
  "serviceAreas.svcGlass",
];

export default function Tier1Section() {
  const { t } = useLanguage();
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary text-white text-xs font-bold px-4 py-1.5 rounded-full mb-4">
            {t("serviceAreas.tier1Badge")}
          </span>
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            {t("serviceAreas.tier1H2")}
          </h2>
          <p className="text-base text-[#374151]">
            {t("serviceAreas.tier1Sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tier1Areas.map((area) => (
            <div
              key={area.slug}
              className="bg-white rounded-xl border-2 border-primary p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <h3 className="text-xl font-bold text-secondary mb-3">
                {area.name}
              </h3>

              <span className="inline-block bg-[#fbbf24] text-secondary text-xs font-bold px-3 py-1 rounded-full mb-3">
                {t("serviceAreas.cardTimeTier1")}
              </span>

              <p className="text-xs text-[#374151] mb-4">
                {t("serviceAreas.cardZipLabel")}{area.zips.length > 1 ? t("serviceAreas.cardZipPlural") : ""}: {area.zips.join(", ")}
              </p>

              <div className="mb-4">
                <p className="text-xs font-bold text-[#374151] uppercase tracking-wider mb-2">
                  {t("serviceAreas.cardServicesLabel")}
                </p>
                <div className="space-y-2">
                  {serviceKeys.map((svcKey) => (
                    <div
                      key={svcKey}
                      className="flex items-center gap-2 text-sm text-secondary"
                    >
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-primary" />
                      </span>
                      {t(svcKey)}
                    </div>
                  ))}
                </div>
              </div>

              <Link
                to={`/impact-windows-${area.slug}/`}
                className="inline-flex items-center gap-1 text-sm font-bold text-primary hover:text-primary-dark transition-colors"
              >
                {t("serviceAreas.cardViewPrefix")} {area.name} {t("serviceAreas.cardViewSuffix")}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}